module.exports = __webpack_public_path__ + "static/media/Ursaring_gaussian2.c1006f0f.png";